(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadOfferRoomTypeDeleteController',LeadOfferRoomTypeDeleteController);

    LeadOfferRoomTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'LeadOfferRoomType'];

    function LeadOfferRoomTypeDeleteController($uibModalInstance, entity, LeadOfferRoomType) {
        var vm = this;
        vm.leadOfferRoomType = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            LeadOfferRoomType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
